const styles = (theme) => ({
  itemIcon: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
});

export default styles;
